<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>
<ng-container *ngIf="displayError; else displayUI">
    <display-error></display-error>
</ng-container>

<ng-template #displayUI>
    <!-- Navigation -->
    <fuse-vertical-navigation class="print:hidden bg-primary-900 dark"
        [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'" [navigation]="navigation.default"
        [opened]="!isScreenSmall">
        <!-- Navigation header hook -->
        <ng-container fuseVerticalNavigationContentHeader>
            <div class="flex items-center justify-between w-full p-4 h-full">
                <span class="leading-5">
                    <p class="text-3xl font-extrabold">CGO</p>
                    <!-- /<p class="text-3xl font-extrabold pb-2">Payment</p> -->
                    <p class="font-medium tracking-tighter">ADMIN PORTAL</p>
                </span>
                <!-- Components -->
                <div class="flex items-center ml-auto">
                    <user *ngIf="user" [showAvatar]="false"></user>
                </div>
            </div>
        </ng-container>
        <!-- Navigation footer hook -->
        <ng-container fuseVerticalNavigationContentFooter>

        </ng-container>
    </fuse-vertical-navigation>

    <!-- Wrapper -->
    <div class="relative top-0 bottom-0 w-screen h-screen overflow-hidden">
        <div class="flex flex-col w-full h-full transition-transform transform duration-400 ease-drawer overflow-hidden">

            <!-- Header -->
            <div
                class="sticky top-0 flex flex-0 justify-between items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden overflow-hidden">
                <!-- Navigation toggle button -->
                <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
                    <mat-icon [svgIcon]="'feather:menu'"></mat-icon>
                </button>
                @if (selectedBrand === 'e-kedai') {
                    <img class="h-full p-4" src="assets/images/logo/eastel.svg">
                }
                <!-- Components -->
                <mat-icon class="invisible" [svgIcon]="'feather:menu'"></mat-icon>
            </div>

            <!-- Content -->
            <div class="flex justify-center flex-auto w-full overflow-auto" #scroll>
                <div class="flex flex-col flex-auto w-full">
                    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
                         Otherwise, layout changes won't be registered and the view won't be updated! -->
                    <router-outlet *ngIf="true"></router-outlet>
                </div>
            </div>

        </div>
    </div>
</ng-template>
